import { render, staticRenderFns } from "./Revenues.vue?vue&type=template&id=bb9b4634&scoped=true&"
import script from "./Revenues.vue?vue&type=script&lang=js&"
export * from "./Revenues.vue?vue&type=script&lang=js&"
import style0 from "./Revenues.vue?vue&type=style&index=0&id=bb9b4634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b4634",
  null
  
)

export default component.exports